import { render, staticRenderFns } from "./Rent.vue?vue&type=template&id=c564fdce&scoped=true"
import script from "./Rent.vue?vue&type=script&lang=js"
export * from "./Rent.vue?vue&type=script&lang=js"
import style0 from "./Rent.vue?vue&type=style&index=0&id=c564fdce&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c564fdce",
  null
  
)

export default component.exports